<div class="route-via">
  @if (viaRouteList.length) {
      <span>Via</span>
  }
  @for (viaRoute of viaRouteList; track trackByFn(i); let i = $index) {
    <div class="via">
      <app-google-place-search [placeHolder]='viaLocationMessage' [locationModel]="viaRoute" tabindex="{{i+3}}"
        [currentLocation]='viaRoute.Name' (onValueChanged)='getSelectVia($event, viaRoute)'
        (onSubmit)="submitSearch()" >
      </app-google-place-search>
      <button (click)="onCloseViaBox(viaRoute)" class="btn delete" alt="Remove Via Option"
      aria-label="Remove Via Option"></button>
    </div>
  }

  @if (this.viaRouteList.length == 4) {
    <div class="red-label">{{this.maxViaErrorMessage}}</div>
  }
</div>